import { render, staticRenderFns } from "./AddonProductModalMobile.vue?vue&type=template&id=0b103ee5&scoped=true&"
import script from "./AddonProductModalMobile.vue?vue&type=script&lang=js&"
export * from "./AddonProductModalMobile.vue?vue&type=script&lang=js&"
import style0 from "./AddonProductModalMobile.vue?vue&type=style&index=0&id=0b103ee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b103ee5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b103ee5')) {
      api.createRecord('0b103ee5', component.options)
    } else {
      api.reload('0b103ee5', component.options)
    }
    module.hot.accept("./AddonProductModalMobile.vue?vue&type=template&id=0b103ee5&scoped=true&", function () {
      api.rerender('0b103ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Step2Mobile/AddonProductModalMobile.vue"
export default component.exports